import nudgebuddyImg from "../assets/images/projects/nudgebuddy.png";
import fraudguardImg from "../assets/images/projects/fraudguard.png";
import geotoolkitsImg from "../assets/images/projects/geotoolkits.webp";
import liranImg from "../assets/images/projects/liran.png";
import defifundrImg from "../assets/images/projects/defifundr.webp";
import practilinkImg from "../assets/images/projects/practilink.png";
import gosellytImg from "../assets/images/projects/gosellyt.png";
import solainImg from "../assets/images/projects/solain.png";
import scribenetImg from "../assets/images/projects/scribenet.png";

export const personalProjects = [
  {
    slug: "nudgebuddy",
    kind: "personal",
    name: "Nudge Buddy",
    tagline: "Voice-first AI focus & productivity assistant",
    about:
      "A voice-first AI productivity assistant — add tasks, manage your calendar, and run focus sessions by voice, with proactive check-ins to keep you on track.",
    image: nudgebuddyImg,
    link: "http://nudgebuddy.xyz/",
  },
  {
    slug: "fraudguard",
    kind: "personal",
    name: "FraudGuard",
    date: "January 2026",
    tagline: "Open-source fraud detection package for Node.js",
    about:
      "An open source, on-premise fraud detection package for Node.js applications, with incremental learning for its AI model and velocity checks.",
    image: fraudguardImg,
    link: "https://www.npmjs.com/package/@bolu1/fraud-guard",
    linkLabel: "View on npm",
  },
  {
    slug: "geotoolkits",
    kind: "personal",
    name: "GeoToolkits",
    date: "July 2025",
    tagline: "TypeScript library for geospatial data processing",
    about:
      "A TypeScript library for geospatial data processing, area calculations, and geofencing — with type-safe support for GeoJSON, KML, and KMZ file formats.",
    image: geotoolkitsImg,
    link: "https://www.npmjs.com/package/geo-toolkits",
    linkLabel: "View on npm",
  },
  {
    slug: "liran",
    kind: "personal",
    name: "Liran",
    tagline: "On-premise natural-language interface for Node.js",
    about:
      "An on-premise natural-language interface for Node.js — local LLM integration, tool calling, and database connectivity, without sending data to the cloud.",
    image: liranImg,
    link: "https://www.npmjs.com/package/liran-backend-sdk",
    linkLabel: "View on npm",
  },
  {
    slug: "defifundr",
    kind: "personal",
    name: "DefiFundr",
    date: "",
    tagline: "Decentralized payroll & invoice platform",
    about:
      "A decentralized payroll and invoice platform — automating salary and freelancer payments across Ethereum, Solana, and StarkNet via smart contracts.",
    image: defifundrImg,
  },
];

export const contractProjects = [
  {
    slug: "practilink",
    kind: "contract",
    name: "Practilink",
    tagline: "Nursery & early-years management platform",
    about:
      "PractiLink helps nursery teams stay organised — activity planning, staff rotas, daily mood check-ins, and a practitioner community in one dashboard.",
    image: practilinkImg,
    link: "https://www.practilink.co.uk/homepage",
  },
  {
    slug: "gosellyt",
    kind: "contract",
    name: "Gosellyt (Sellyt)",
    tagline: "Social-commerce assistant for chat-based vendors",
    about:
      "Sellyt helps vendors turn WhatsApp, Instagram, and Facebook chats into tracked sales — shared inbox, shareable catalog, and conversation tracking.",
    image: gosellytImg,
    link: "https://gosellyt.com/",
  },
  {
    slug: "solain",
    kind: "contract",
    name: "Solain",
    tagline: "Real-time satellite analytics platform",
    about:
      "Solain monitors heat, land, and construction at planetary scale — real-time satellite analytics for urban climate, infrastructure, and environmental risk.",
    image: solainImg,
    link: "https://thermal.solain.de/",
  },
  {
    slug: "scribenet",
    kind: "contract",
    name: "Scribenet",
    tagline: "Community WiFi service",
    about:
      "ScribeNet sells short-term community WiFi in Malete — daily and weekly plans with real-time usage tracking and a vendor QR-voucher program.",
    image: scribenetImg,
    link: "https://scribenetconnect.com/",
  },
];

export const allProjects = [...personalProjects, ...contractProjects];
